<template>
  <div :class="{ 'modal-wrapper bg-on-cont-dim  p-fixed': componentMounted }">
    <Transition name="slide-fade" appear>
      <div v-if="isOpen" class="modal-overlay d-flex justify-center p-fixed" @click="closeModal">
        <div :class="['modal-container d-flex column bg-cont-white color-on-cont-bright ']" :style="modalStyle" @click.stop>
          <div class="modal-header d-flex justify-between items-center w-100 text-bold text-b18 p-relative">
            <div class="modal-header-content leaning-24 d-flex justify-between items-center w-100">
              <h1>
                <slot name="header"></slot>
              </h1>
              <span v-if="closable" class="modal-header-content-close d-flex justify-center items-center" @click="closeModal">
                <Icons name="close" />
              </span>
            </div>
          </div>
          <div class="modal-body w-100">
            <slot name="body"></slot>
          </div>
          <div v-if="$slots.footer" class="modal-footer w-100">
            <slot name="footer"> </slot>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { computed, nextTick, ref, toRefs, watch } from 'vue';
import Icons from '@/components/base/icon/index.vue';
const props = withDefaults(
  defineProps<{
    isOpen: boolean;
    closable?: boolean;
    onClose?: () => void;
    modalWidth?: number | string;
    modalHeight?: number | string;
    widthFull?: boolean;
  }>(),
  {
    closable: true,
    modalWidth: '100%',
    modalHeight: 'fit-content',
  }
);

const { isOpen, onClose, modalWidth, modalHeight } = toRefs(props);
const emit = defineEmits(['update:isOpen']);
const closing = ref(false);
const componentMounted = ref(false);
const modalStyle = computed(() => {
  return {
    width: typeof modalWidth.value === 'number' ? modalWidth.value + 'px' : modalWidth.value,
    height: typeof modalHeight.value === 'number' ? modalHeight.value + 'px' : modalHeight.value,
  };
});
function closeModal() {
  closing.value = true;
  componentMounted.value = false;
  nextTick(() => {
    emit('update:isOpen', false);
    closing.value = false;
    onClose?.value && onClose.value();
  });
}
watch(
  () => isOpen.value,
  (newVal) => {
    if (newVal) {
      document.body.style.overflow = 'hidden';
      componentMounted.value = true;
    } else {
      document.body.style.overflow = '';
      componentMounted.value = false;
    }
  }
);
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
